/* eslint import/first: 0 */
window.process = {
  cwd: () => '', env: { NODE_ENV: 'development' }
};
import '../react/renderer';
